import { UpdateUserPayload } from 'modules/roles-manager/domain/resources/role-users';
import { useUpdateRoleUserMutation } from 'modules/roles-manager/store';
import { useCallback } from 'react';

/** Изменить пользователя организации; новая версия сама ложится на все закэшированные страницы. */
export function useUpdateUser(tournamentId?: number) {
  const [trigger, { isLoading }] = useUpdateRoleUserMutation();

  const updateUser = useCallback(
    async (payload: UpdateUserPayload) => {
      if (!tournamentId) throw new Error('No tournamentId');
      return trigger({ organizerId: tournamentId, payload }).unwrap();
    },
    [tournamentId, trigger],
  );

  return { updateUser, isLoading };
}

export default useUpdateUser;
